export enum AlertPosition {
  LEFT = 'left',
  RIGHT = 'right'
}

export enum AlertSeverity {
  SUCCESS = 'success',
  ERROR = 'error'
}

export enum MarginSize {
  NONE = 'none',
  NARROW = 'narrow',
  WIDE = 'wide'
}

export enum LangValue {
  EN = 'en',
  FI = 'fi',
  SV = 'sv'
}

export enum LangText {
  EN = 'EN',
  FI = 'FI',
  SV = 'SV'
}

export enum LinkType {
  ROUTED = 'routed',
  BASIC = 'basic'
}

export enum LinkStyleType {
  NORMAL = 'normal',
  IMPORTANT = 'important'
}

export enum AddressLocationType {
  DOMESTIC = 'FI',
  FOREIGN = 'foreign'
}
